import React, { useEffect, useState } from 'react';
import { useSetAtom } from 'jotai';
import { Typography, Box, Paper } from '@mui/material';

import {
  CustomImage as TopconectLogo,
  PasswordForm,
  TextInputForm,
} from '../../sharedComponents';
import { LoginButton } from './components';
import { pageAtom } from '../../atoms';
import { PAGE } from '../../constant/page';
import { LoginPageText } from '../../texts';
import { REGEX } from '../../constant';
import logo from '../../assets/icon.svg';

const boxStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '80px',
};

const paperStyles = {
  minWidth: '40%',
  minHeight: '680px',
  maxWidth: '80%',
  paddingX: '5%',
  paddingY: '20px',
};

const LoginPage = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const [formValidation, setFormValidation] = useState({
    email: true,
    password: true,
  });

  const updateFormData = (key: string, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const updateValidity = (key: string, value: boolean) => {
    setFormValidation((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const setPage = useSetAtom(pageAtom);

  useEffect(() => {
    document.title = 'Topconect Web';
  }, []);

  return (
    <Box {...boxStyles}>
      <Paper elevation={3} sx={paperStyles}>
        <Box
          display='flex'
          flexDirection='column'
          alignItems='center'
          gap='30px'
        >
          <TopconectLogo src={logo} alt='logo' width='200px' />

          <Typography variant='h6'>{LoginPageText.Login_Disc}</Typography>

          <TextInputForm
            label='メールアドレス'
            type='email'
            value={formData.email}
            setValue={(value) => updateFormData('email', value)}
            isValid={formValidation.email}
            setIsValid={(value) => updateValidity('email', value)}
            validate={(input) =>
              RegExp(REGEX.EMAIL).exec(input) ? true : false
            }
            errorMessage='正しいメールアドレスの形式で入力してください'
          />

          <PasswordForm
            label='パスワード'
            value={formData.password}
            setValue={(value) => updateFormData('password', value)}
            isValid={formValidation.password}
            setIsValid={(value) => updateValidity('password', value)}
            validate={() => true}
            errorMessage='パスワードを入力してください'
          />

          <LoginButton
            formData={formData}
            formValidation={formValidation}
            setFormValidation={setFormValidation}
          />

          {/* <Typography
            sx={{ cursor: 'pointer', textDecoration: 'underline' }}
            variant='body1'
            onClick={() => {
              setPage(PAGE.CHANGE_PASSWORD);
            }}
          >
            {LoginPageText.Forget_Password}
          </Typography> */}

          <Box display='flex' flexDirection='row'>
            <Typography variant='body1' marginRight={2}>
              {LoginPageText.HaveNot_Account}
            </Typography>
            <Typography
              sx={{ cursor: 'pointer', textDecoration: 'underline' }}
              variant='body1'
              onClick={() => {
                setPage(PAGE.TERMS_OF_USE);
              }}
            >
              {LoginPageText.Register_Account}
            </Typography>
          </Box>

          {/* <Typography
            sx={{ cursor: 'pointer', textDecoration: 'underline' }}
            variant='body1'
            onClick={() => {
              setPage(PAGE.REACTIVATION);
            }}
          >
            {LoginPageText.Activation_Resend}
          </Typography> */}
        </Box>
      </Paper>
    </Box>
  );
};

export default React.memo(LoginPage);
